module.exports = __webpack_public_path__ + "img/partner-2.7106e78c.7106e78c.jpg";